import { Box, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import {
  Divider,
  Tab,
  Tabs,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  ReadMoreIcon,
} from "../../mui";
import React, { useState, useEffect } from "react";
import UIWrapper from "../../components/UIWrapper";
import ShipmentInquiriesService from "../../services/ShipmentInquiriesService";
import { snackbarActions } from "../../Store/snackbar";
import { useDispatch } from "react-redux";
import InquiriesSummary from "./InquiriesSummary";
import UploadManifest from "./UploadManifest";
import CompletedCancelledInquiries from "./CompleteCancelledInquiries";
import InquiryDetails from "./InquiryDetails";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.selectedNavItemHover.bgColor,
    color: theme.palette.selectedNavItem.color,
  },
}));

const inquiryTableColumns = ["Inquiry ID", "Study", "Status", "More"];

const inquiryFormSchema = {
  inquiry_id: "",
  user_id: "",
  first_name: "",
  last_name: "",
  organization_name: "",
  phone: "",
  email: "",
  attention_to: "",
  address_line_one: "",
  address_line_two: "",
  city: "",
  state: "",
  zipcode: "",
  study: "",
  status: "",
  created_at: "",
  modified_at: "",
  last_modified_status: "",
  cohorts: [
    {
      id: "",
      inquiry_id: "",
      cohort_id: "",
      bio_sample_type: "",
      number_of_units: "",
      inventory_code: [],
      volume_per_unit: "",
      volume_per_unit_uom: "",
      aliquot_concentration: "",
      dna_total_yield_perunit: "",
      dna_total_yield_perunit_uom: "",
    },
  ],
  // tracking_number: "",
};

const BioSpecimenAccessProgram = () => {
  const [value, setValue] = useState("one");
  const [comment, setComment] = useState("");
  const [tableData, setTableData] = useState([]);
  const [rowsPerPageLarge, setRowsPerPageLarge] = useState(25);
  const [pageLarge, setPageLarge] = useState(0);
  const [formData, setFormData] = useState(inquiryFormSchema);
  const dispatch = useDispatch();

  const handleChangePageLarge = (event, newPage) => {
    setPageLarge(newPage);
  };

  const handleChangeRowsPerPageLarge = (event) => {
    setRowsPerPageLarge(+event.target.value);
    setPageLarge(0);
  };

  const handleEditRowData = (row) => {
    setFormData((prev) => ({
      inquiry_id: row.inquiry_id,
      status: row.status,
      user_id: row.user_id,
      first_name: row.first_name,
      last_name: row.last_name,
      organization_name: row.organization_name,
      phone: row.phone,
      email: row.email,
      attention_to: row.attention_to,
      address_line_one: row.address_line_one,
      address_line_two: row.address_line_two,
      city: row.city,
      state: row.state,
      zipcode: row.zipcode,
      study: row.study,
      cohorts: row.cohorts,
      last_modified_status: row.last_modified_status,
      // tracking_number: row.tracking_number ? row.tracking_number : "",
    }));

    handleChangeTabs();
    setValue("two");
  };

  const handleChangeTabs = (event, newValue) => {
    newValue === "two" ? setValue("one") : setValue(newValue);
    // setUpdateStatus("");
    // setComment("");
    // cohortInvCode = {};
    setComment("");    
  };

  const getTableData = () => {
    ShipmentInquiriesService.getInquiryList()
      .then((resp) => {
        setTableData(
          resp.data.filter((row) => {
            return (
              row.status !== "completed" &&
              (row.status !== "biorep_rejected" ||
                row.last_modified_status !== "biorep_rejected")
            );
          })
        );
      })
      .catch((err) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: err.message,
          })
        );
      });
  };

  useEffect(() => {
    if (value === "one") {
      getTableData();
    }
  }, []);

  return (
    <UIWrapper title="Shipment Inquiries" paper>
      <Box>
        <Tabs
          value={value}
          onChange={handleChangeTabs}
          textColor="primary"
          indicatorColor="primary"
          aria-label="Bio Specimen Accecc Program"
        >
          <Tab value="one" label="Active" />
          <Tab
            value="two"
            label="Inquiry Details"
            style={{ display: value === "two" ? "block" : "none" }}
          />
          <Tab value="three" label="Completed / Cancelled" />
          <Tab value="four" label="Summary" />
          <Tab
            value="five"
            label="Manage Shipment"
            style={{ display: value === "five" ? "block" : "none" }}
          />
        </Tabs>
        <Divider style={{ width: "100%" }}></Divider>

        {/*  Inquiry Table */}
        {value === "one" && (
          <Stack
            sx={{
              marginTop: "10px",
            }}
          >
            <TableContainer>
              <Table aria-label="Shipment Inquiries Table" size={"small"}>
                <TableHead>
                  <TableRow>
                    {inquiryTableColumns.map((row, index) => (
                      <StyledTableCell align="left" key={index}>
                        {row}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody style={{ border: "none" }}>
                  {tableData.length > 0 ? (
                    tableData
                      .slice(
                        pageLarge * rowsPerPageLarge,
                        pageLarge * rowsPerPageLarge + rowsPerPageLarge
                      )
                      .map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="left">
                            {row.inquiry_id || "None / Null"}
                          </TableCell>
                          <TableCell align="left">
                            {row.study || "None / Null"}
                          </TableCell>
                          <TableCell align="left">
                            {row.status || "None / Null"}
                          </TableCell>
                          <TableCell
                            align="left"
                            onClick={() => handleEditRowData(row)}
                          >
                            <Tooltip
                              title="More Detail"
                              style={{ cursor: "pointer" }}
                            >
                              <ReadMoreIcon color="secondary" />
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={inquiryTableColumns.length + 2}
                      >
                         No Record Found
                        <Box sx={{ py: 6, display: "flex", justifyContent: "center" }}>
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[6, 10, 25]}
                component="div"
                count={tableData.length}
                rowsPerPage={rowsPerPageLarge}
                page={pageLarge}
                onPageChange={handleChangePageLarge}
                onRowsPerPageChange={handleChangeRowsPerPageLarge}
              />
            </TableContainer>
          </Stack>
        )}

        {/*  Inquiry Details */}
        <InquiryDetails
          value={value}
          setValue={setValue}
          formData={formData}
          setFormData={setFormData}
          getTableData={getTableData} // Pass the function as a prop
          comment={comment}
          setComment={setComment}
        />

        {/*  Shipment Management */}
        <UploadManifest
          value={value}
          setValue={setValue}
          formData={formData}
          setFormData={setFormData}       
        />

        {/*  Completed/Cancelled */}
        <CompletedCancelledInquiries
          value={value}
          setValue={setValue}
          setFormData={setFormData}
        />

        {/*  Summary Chart */}
        <InquiriesSummary value={value} tableData={tableData} />
      </Box>
    </UIWrapper>
  );
};

export default BioSpecimenAccessProgram;
